import { PermissionEnum, apiAbortController } from '@ui/src';
import { UploadResponse } from './types';
import api from '../../api/api';

export interface PermissionReponse {
  permissions: PermissionEnum[];
}

export const clientsDocumentsApi = api.injectEndpoints({
  endpoints: (build) => ({
    customersUpload: build.mutation({
      async queryFn(file: File, _queryApi, _extraOptions, fetchWithBQ) {
        const formData = new FormData();
        formData.append('files', file);

        const response = (await fetchWithBQ({
          url: '/v1/uploads',
          method: 'POST',
          body: formData,
        })) as { data: UploadResponse[] };

        return response;
      },
    }),
    addCustomersComment: build.mutation<
      any,
      { id: string; body: { text: string } }
    >({
      query: (data) => ({
        url: `/v1/documents/${data.id}/comments`,
        method: 'POST',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    editCustomersComment: build.mutation<
      any,
      { id: string; commentId: string; body: { text: string } }
    >({
      query: (data) => ({
        url: `/v1/documents/${data.id}/comments/${data.commentId}`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    deleteCustomersComment: build.mutation<
      any,
      { id: string; commentId: string }
    >({
      query: (data) => ({
        url: `/v1/documents/${data.id}/comments/${data.commentId}`,
        method: 'DELETE',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useCustomersUploadMutation,
  useAddCustomersCommentMutation,
  useEditCustomersCommentMutation,
  useDeleteCustomersCommentMutation,
} = clientsDocumentsApi;

export const {
  endpoints: {
    customersUpload,
    addCustomersComment,
    editCustomersComment,
    deleteCustomersComment,
  },
} = clientsDocumentsApi;
